import CategoryLink from './components/CategoryLink'
import ContentSection from './components/ContentSection'
import PageHeader from './components/PageHeader'
import StickyUseTemplateDesktop from './components/StickyUseTemplateDesktop'
import StickyUseTemplateMobile from './components/StickyUseTemplateMobile'

import FaqItems from './components/FaqItems'
import type {FaqItemsProps, FaqItem} from './components/FaqItems'

export type {FaqItem, FaqItemsProps}

export default {
  CategoryLink,
  ContentSection,
  PageHeader,
  StickyUseTemplateDesktop,
  StickyUseTemplateMobile,
  FaqItems,
}
